// Constantes pour les listes de sélection
export const PRACTICE_LOCATIONS = ["Cabinet", "Domicile", "Téléconsultation", "Remplaçant"] as const;

export const PARKING_TYPES = ["Gratuit", "Payant", "Place réservée PMR", "Pas de stationnement"] as const;

export const PREFERRED_CONTACTS = ["Téléphone", "Mail", "SMS", "Autres"] as const;

export const APPOINTMENT_METHODS = ["Téléphone", "Mail", "SMS", "En ligne"] as const;

export const NEW_PATIENTS_POLICIES = ["Oui", "Non", "Oui mais dans mes spécialités seulement"] as const;

export const SESSION_DURATIONS = ["20min", "30min", "45min", "60min", "Libre"] as const;

export const PATIENT_TYPES = [
  "Enfants", "Sportifs", "Adolescents", "Adultes", "Grand âge", 
  "Personnes en situation de surpoids ou d'obésité"
] as const;

export const PRACTICE_MODES = ["Exercice conventionné", "Dépassement d'honoraires (DE, HN)", "Activité déconventionnée"] as const;

export const PAYMENT_METHODS = [
  "Tiers payant CPAM pratiqué", "Tiers payant Mutuelle pratiqué",
  "Chèque", "Espèces", "Carte bleue", "Virement", "Paiement en ligne"
] as const;

export const COORDINATED_PRACTICE_TYPES = ["CPTS", "MSP", "Autres"] as const;

export const SPECIALTIES = [
  "Céphalées", "Cheville-Pied", "Cicatrices", "Commotions cérébrales", "Coude", 
  "Douleur", "Epaule", "Genou", "Gériatrie", "Hanche", "Lésions musculaires", 
  "Main", "Neurologie centrale", "Prise en charge de l'obésité", "Oncologie-Sénologie", 
  "Oro-maxillo-facial", "Pédiatrie-Périnatalité", "Pneumologie-Respiratoire", 
  "Rachis-dos", "Kiné respiratoire Enfant", "Sport", "Syndromes canalaires", 
  "Tendinopathies", "Urogynéco-périnéologie femme", "Uropérinéologie homme", "Vestibulaire"
] as const;
export const TECHNIQUES = [
  "CGE", "Drainage Lymphatique Manuel", "Dry needling", "Entretien Motivationnel", 
  "Education thérapeutique du Patient", "Maitland", "McKenzie-MDT", "Mézières", 
  "Mulligan", "Neurodynamique", "Orthèses", "Pilates", "Thérapie manuelle", "Autres"
] as const;
export const EQUIPMENT = [
  "Balnéothérapie", "Ondes de choc", "BFR - Restriction du flux sanguin", "Salle de musculation",
  "Técar-thérapie", "Ultrasons", "Plan de Bobath ou table de grande taille",
  "Cryothérapie", "Pressothérapie", "Matériel prise en charge vestibulaire",
  "Dynamomètre", "LPG", "Matériel prise en charge Urogynécologie",
  "Matériel de prise en charge respiratoire", "Electrothérapie", "Laser",
  "Lunettes stroboscopiques", "EMG", "Autres"
] as const;
export const ACCESSIBILITY = ["Accès fauteuil roulant", "Parking", "Transport en commun", "Ascenseur", "Rez-de-chaussée"] as const;
export const LANGUAGES = ["Français", "Anglais", "Espagnol", "Allemand", "Italien", "Arabe", "Chinois", "Langue des signes", "Autres"] as const;
export const SPORTS = [
  "Football", "Rugby", "Tennis", "Basketball", "Cyclisme", "Course à pied/Trail",
  "Natation", "Sports de combat", "Danse", "Gymnastique", "Musculation", "Autres"
] as const;
export const OTHER_ACTIVITIES = [
  "Massage bien-être", "Bilan du sportif", "Cours de Pilates",
  "Préparateur physique", "Ostéopathe", "Diététicien", "Autres"
] as const;
// BODY_ZONES supprimé selon le retour client (bloc non nécessaire)

// Types pour les filtres dynamiques
export interface FilterValue {
  id: number;
  value: string;
  active: boolean;
  position: number;
  physiotherapists_count?: number;
}

export interface FilterCategory {
  id: number;
  name: string;
  key: string;
  description: string | null;
  active: boolean;
  position: number;
  filter_values: FilterValue[];
}

// Fonctions pour récupérer les filtres depuis l'API
export const getFilterCategories = async (): Promise<FilterCategory[]> => {
  try {
    const response = await fetch('/admin/filter_categories.json');
    if (!response.ok) throw new Error('Failed to fetch filter categories');
    return await response.json();
  } catch (error) {
    console.error('Error fetching filter categories:', error);
    return [];
  }
};

export const getFilterValuesByCategory = async (categoryKey: string): Promise<string[]> => {
  try {
    const categories = await getFilterCategories();
    const category = categories.find(cat => cat.key === categoryKey);
    return category?.filter_values.filter(fv => fv.active).map(fv => fv.value) || [];
  } catch (error) {
    console.error(`Error fetching filter values for ${categoryKey}:`, error);
    return [];
  }
};

// Fonctions de compatibilité pour les anciennes constantes
export const getSpecialties = () => getFilterValuesByCategory('SPECIALTIES');
export const getTechniques = () => getFilterValuesByCategory('TECHNIQUES');
export const getEquipment = () => getFilterValuesByCategory('EQUIPMENT');
export const getBodyZones = () => getFilterValuesByCategory('BODY_ZONES');
export const getAccessibility = () => getFilterValuesByCategory('ACCESSIBILITY');
export const getLanguages = () => getFilterValuesByCategory('LANGUAGES'); 
